import React from 'react'
import Head from 'next/head'
import CitiesContent from 'components/cities_content'
import { All_Cities_With_Broker_And_NavDocument } from 'graphql/generated/types'
import ApplicationLayout from 'layouts/application'
import { initializeApollo, addApolloState } from 'util/apolloClient'

const title = `Stock Brokers`
const description = `Stock Brokers`

export default function Software(props) {
  const { data: pageData } = props

  const {
    all_brokers: { data: allBrokers },
    all_calculators: { data: navCalculators },
    all_cities: { data: allCities },
    all_pages: { data: allPages },
  } = pageData

  return (
    <ApplicationLayout
      allBrokers={allBrokers}
      navCalculators={navCalculators}
      allPages={allPages}
    >
      <Head>
        <title>{title}</title>
        <meta name="description" content={description} />
      </Head>
      <CitiesContent allCities={allCities} />
    </ApplicationLayout>
  )
}

export async function getStaticProps() {
  const apolloClient = initializeApollo()

  const queryResults = await apolloClient.query({
    query: All_Cities_With_Broker_And_NavDocument,
  })
  const { data } = queryResults

  return addApolloState(apolloClient, { props: { data } })
}
